import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppClientPage.';
  public static readonly clientEditorTitle = `${Id.prefix}clientEditorTitle`;
  public static readonly clientGlossary = `${Id.prefix}clientGlossary`;
}

export class LangAppClientPage {
  private constructor() {}
  public static clientEditorTitle(): string {
    return interpolate(Id.clientEditorTitle);
  }
  public static clientGlossary(): string {
    return interpolate(Id.clientGlossary);
  }
}

export class AppClientPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.clientEditorTitle, "{{glossary 'client'}} Editor", 'Title for the client editor page');
    register.add(Id.clientGlossary, "{{glossary 'client'}}", 'Glossary term for client (singular)');
  }
}
